import React from 'react';

export default function Checkout() {
  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold mb-4">Checkout</h1>
      <p className="text-xl text-gray-600 mb-6">Proceed with your subscription plan.</p>

      {/* Valuation Disclaimer */}
      <div className="max-w-2xl bg-slate-50 border border-slate-200 rounded-lg p-4 mb-8">
        <p className="text-xs text-slate-600 leading-relaxed">
          <span className="font-semibold">Disclaimer:</span> Valuations provided by this platform are estimates based on available market data, comparable sales, and statistical modeling. They are not certified appraisals and should not be used as the sole basis for financial, legal, or investment decisions. We recommend consulting a licensed appraiser or broker for formal property valuations.
        </p>
      </div>

      {/* Add checkout form or integration here */}
    </div>
  );
}
